import React, { useState, useEffect } from 'react';
import { Button, Grid2 as Grid, Paper,
     Typography, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox,
      Box, List, ListItem, ListItemText, Skeleton, IconButton } from '@mui/material';
import { getUnassignedOrders } from 'api/orders';
import { getUnassignedRoutes } from 'api/routes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { addOrdersToRoute, removeOrdersFromRoute } from 'api/routes';
import { Route, Order } from 'typings/models';
import OrderSelection from './orderSelection';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const RoutesAdminPage = () => {
    const [routes, setRoutes] = useState<Route[]>([]);
    const [orders, setOrders] = useState<Order[]>([]);
    const [selectedRouteId, setSelectedRouteId] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedOrderIds, setSelectedOrderIds] = useState<string[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [openBackdrop, setOpenBackdrop] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const routesData = await getUnassignedRoutes();
            setRoutes(routesData);
            const ordersData = await getUnassignedOrders();
            setOrders(ordersData);
            setLoading(false);
        };
        fetchData();
    }, []);

    const action = (
       <>
       <IconButton>
        <CloseIcon />
       </IconButton>
       </>
    )

    const handleRouteSelect = async (routeId: string) => {
        setSelectedRouteId(routeId);
        const ordersData = await getUnassignedOrders(); // Fetch unassigned orders for the selected route
        setOrders(ordersData);
    };

    const handleAddOrder = (orderId: string) => {
        addOrdersToRoute({routeId: selectedRouteId, orderIds: [orderId]});
    };

    const handleAddOrdersToRoute = async (routeId: string) => {
        setOpenBackdrop(true);
        const newRoute = await addOrdersToRoute({routeId: routeId, orderIds: selectedOrderIds});
        if (!newRoute) {
            setOpenBackdrop(false);
            setSnackbarMessage('Error al agregar las ordenes a la ruta');
            setSnackbarOpen(true);
            return;
        }
        setRoutes(routes.map(r => r.id === newRoute.id ? newRoute : r));
        setOrders(orders.filter(o => !selectedOrderIds.includes(o.id)));
        setOpenBackdrop(false);
        setSnackbarMessage(`${selectedOrderIds.length} ${selectedOrderIds.length === 1 ? 'Orden' : 'Ordenes'} agregada${selectedOrderIds.length === 1 ? '' : 's'} a la ruta ${newRoute.name}`);
        setSelectedOrderIds([]);
        setSnackbarOpen(true);
    }

    const handleRemoveOrder = async (orderId: string, route: Route) => {
        const newRoute = await removeOrdersFromRoute({routeId: route.id, orderIds: [orderId]});
        const order = route.orders.find(o => o.id === orderId);
        setRoutes(routes.map(r => r.id === newRoute.id ? newRoute : r));
        if (order) {
            setOrders([...orders, order]);
        }



    };

    if (loading) {
        return <Skeleton variant="rectangular" width="100%" height={118} />;
    }

    return (
        <Grid container spacing={2} padding={2}>
            <Backdrop
  sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
  open={openBackdrop}
  onClick={() => setOpenBackdrop(false)}
>
  <CircularProgress color="inherit" />
</Backdrop>
            <Grid size={{xs: 12, sm: 6}}>
                <Typography variant="h6">Rutas</Typography>
                {routes.map(route => {
                    const orderedOrders = route.orders.sort((a, b) => a.client.name.localeCompare(b.client.name));
                    return (
                    <Accordion key={route.id} onChange={() => handleRouteSelect(route.id)}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{route.name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box>
                                <Typography variant="body1">Orders:</Typography>
                                <List>
                                    {orderedOrders.map(order => (
                                        <ListItem key={order.id}>
                                            <ListItemText primary={`${order.id} - ${order.client.name}`} />
                                            <IconButton
                                                color="error"
                                                onClick={() => handleRemoveOrder(order.id, route)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItem>
                                    ))}
                                </List>
                                { selectedOrderIds.length > 0 &&
                                    
                                    <Button variant="contained" color="primary" onClick={() => handleAddOrdersToRoute(route.id)}>
                                    Agregar {selectedOrderIds.length} {selectedOrderIds.length === 1 ? 'Orden' : 'Ordenes'}
                                </Button>}
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                )
            }
                )}
            </Grid>
            <Grid size={{xs: 12, sm: 6}}>
            <OrderSelection orders={orders} selectedOrderIds={selectedOrderIds} setSelectedOrderIds={setSelectedOrderIds} />
            </Grid>
            <Snackbar
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success">
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Grid>
    );
};

export default RoutesAdminPage;
